import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20241121 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="21 Listopada, 2024" header="Nowa wersja 1.5.0" labels={["bugfix", "feature"]}>
      <ChangelogBody title="1. Poprawki do modułu wiadomości email">
        <ul>
          <li>
            - Na ekranie <LinkTo to={routes.EMAILS_TRIGGERS}>wyzwalaczy</LinkTo> dodano informację o tym czy szablon
            email jest aktywny.
          </li>
          <li>
            - Na ekranie <LinkTo to={routes.EMAILS_TRIGGERS_ADD}>dodawania</LinkTo> i edycji szablonu email dodano
            możliwość aktywowania i dezaktywowania szablonu.
          </li>
          <li>
            - Na ekranie <LinkTo to={routes.EMAILS_TRIGGERS_ADD}>dodawania</LinkTo> i edycji szablonu email
            zabezpieczono możliwość przypisywania kategorii do szablonów systemowych. Przy wyborze kategorii systemowej,
            nie ma możliwości edycji kategorii.
          </li>
        </ul>
      </ChangelogBody>
      <ChangelogBody title="2. Nowy mechanizm filtrowania">
        Na ekranie <LinkTo to={routes.COURSES}>kursów</LinkTo> dodano nowy mechanizm filtrowania. Teraz można filtrować
        po id, nazwie, miejscach oraz statusie. Dodano również możliwość czyszczenia filtrów.
      </ChangelogBody>
      <ChangelogBody title="3. Poprawki do edycji harmonogramu">
        Na ekranie <LinkTo to={routes.COURSES_EDIT_NESTED.SCHEDULE("1")}>edycji harmonogramu</LinkTo> poprawiono edycję
        zdarzeń.
      </ChangelogBody>
    </ChangelogArticle>
  );
};
